import { toast } from 'sonner'

/*
 * Opens a URL in a new window/tab and handles popup blockers.
 * If the popup is blocked, it shows a toast notification with the URL.
 */
export function openWindowSafe(url: string, target = '_blank'): Window | null {
	try {
		const parsed = new URL(url, window.location.origin)
		if (!['http:', 'https:'].includes(parsed.protocol)) {
			console.warn('openWindowSafe: blocked non-http(s) URL:', url)
			return null
		}
	} catch {
		console.warn('openWindowSafe: invalid URL:', url)
		return null
	}

	const newWindow = window.open(url, target)

	if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
		// Popup blocked
		toast.info('Popup blocked. Please allow popups or copy this link manually.', {
			description: url,
			duration: 10000,
			action: {
				label: 'Open again',
				onClick: () => window.open(url, target),
			},
			cancel: {
				label: 'Dismiss',
				onClick: () => {},
			},
		})
		return null
	}

	return newWindow
}
